// Install Temporal on globalThis before anything else loads. Schedule-X 4
// does `event.start instanceof Temporal.ZonedDateTime` against globalThis.Temporal,
// so we need every consumer (Schedule-X's bundle and our code) to see the same
// Temporal namespace. Native Temporal lands later — drop this import once Safari
// + our minimum Node both support it natively.
import "temporal-polyfill/global"

import "@hotwired/turbo-rails"

import "./application.css"

import "../controllers"
import { drainPendingToasts, restorePendingScroll } from "../components/calendarUtils"

// Drain any toasts queued by a React island just before it called
// window.location.reload(). Stimulus controllers attach automatically once
// the nodes land in the DOM, so this only needs to run on initial load
// and after every Turbo navigation. Same hook restores any scroll
// position the calendar toolbar stashed before a Prev/Next navigation.
const onPageReady = () => {
  drainPendingToasts()
  restorePendingScroll()
}
document.addEventListener("turbo:load", onPageReady)
document.addEventListener("DOMContentLoaded", onPageReady)
